import { createSvgIcon } from '@mui/material/utils';

export const CheckboxUncheckedIcon = createSvgIcon(
    <svg viewBox="0 0 20 20">
        <rect width="18" height="18" x="1" y="1" rx="4" fill="none" strokeWidth="2" />
    </svg>,
    "CheckboxUnchecked"
);

export default CheckboxUncheckedIcon;
